import { Product } from '@infura/packages.api'
import { V1Project } from '@infura/packages.uks'

export namespace InfuraStats {
  export type ChartDisplayMode = 'totals' | 'percent'
  export type ChartType = 'stacked-line' | 'stacked-column'
  export type ProductType = 'all-products' | Product
  export type ProductName = 'Web3 API' | 'Ethereum Beacon Chain' | 'IPFS'
  export type AnalyticsPeriod = '30d' | '7d' | '24h' | '1h' | '15m'

  export enum AnalyticsDurations {
    LAST_15_MINUTES = 'Last 15 Minutes',
    LAST_1_HOUR = 'Last 1 Hour',
    LAST_24_HOURS = 'Last 24 Hours',
    LAST_7_DAYS = 'Last 7 Days',
    LAST_30_DAYS = 'Last 30 Days',
    CUSTOM_TIMEFRAME = 'Custom Timeframe'
  }

  export type ProductDetails = {
    name: ProductName
    type: Product | 'all-products'
    showAllProjects: boolean
    timePeriods: Array<AnalyticsDurations>
  }

  export type StatsState = {
    projects: Array<V1Project>
    hasProjects: boolean
    product: ProductDetails
    projectId: string
    period: AnalyticsPeriod
    startDate: string
    endDate: string
    duration: AnalyticsDurations
    showSampleData: boolean
    setPeriod: (newDuration: AnalyticsPeriod) => void
    setShowSampleData: (show: boolean) => void
  }

  export type StatsSharedState = {
    duration: AnalyticsDurations
    setDuration: (newDuration: AnalyticsDurations) => void
    period: AnalyticsPeriod
    setPeriod: (newDuration: AnalyticsPeriod) => void
    product: ProductDetails
    setProduct: (newProduct: ProductDetails) => void

    viewAllProjects: boolean
    toggleViewAllProjects: () => void
  }

  export type RequestActivityItem = {
    network: string
    method: string
    failures: number
    value: number
    success: number
    failed_requests: number
    success_requests: number
    key?: number
    '200s': number
    '500s': number
    '300s': number
    '400s': number
  }

  export type CallActivityItem = {
    contract_address: string
    key: number
    network: string
    signature: string
    value: number
  }

  export type MethodVolumeRawItem = {
    method: string
    total_count: number
    ts: string
    value: number
    batch: number
    total: number
  }

  export type NetworkVolumeRawItem = {
    network: string
    total_count: number
    ts: string
    value: number
    batch: number
    total: number
  }

  export type TimeseriesDataRawItem = {
    ts: string
    value: number
    batch?: number
    total?: number
  }

  export type TimeseriesDataPoint =
    | {
        date: string
        value?: number
        total?: number
        batch?: number
      }
    | {
        [key: string]: number
      }

  export type ChartLabelConfig = {
    dataKey: string
    text: string
    tooltipText: string | number
    color?: string
  }

  export type TimeseriesData = {
    labels: Array<ChartLabelConfig>
    timeseries: LineChartTimeseries
  }

  export type MethodVolumeRawData = Array<MethodVolumeRawItem>
  export type NetworkVolumeRawData = Array<NetworkVolumeRawItem>
  export type LineChartTimeseries = Array<TimeseriesDataPoint>

  export type NetworkOptions = {
    value: string
    text: string
  }
}
